import {
  GetApiTimesheetsByUuidEntriesError,
  GetApiTimesheetsByUuidEntriesResponse,
  GetApiTimesheetsByUuidEntriesVariables,
  useGetTimesheetEntries as useGetApiTimesheetEntries,
} from '@sit/client-shared';
import { SkipToken, skipToken, UseQueryOptions } from '@tanstack/react-query';

export function useGetTimesheetEntries<TData = GetApiTimesheetsByUuidEntriesResponse>(
  variables: GetApiTimesheetsByUuidEntriesVariables | SkipToken,
  options?: Omit<
    UseQueryOptions<GetApiTimesheetsByUuidEntriesResponse, GetApiTimesheetsByUuidEntriesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) {
  return useGetApiTimesheetEntries(
    variables === skipToken
      ? skipToken
      : {
          pathParams: variables.pathParams,
          queryParams: {
            ...variables.queryParams,
            includeAllocationChildren: 'true',
          },
        },
    options,
  );
}
